<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Label</h5>
            </b-col>
        </b-row>

        <b-input-group size="sm">
            <b-input v-model="component.name"
                     :state="component.name && component.name.length ? null : false"
                     placeholder="Name"
                     :formatter="uppercase"
            />
            <b-input v-model="component.catalogNo" placeholder="Catalog Number" class="col-sm-5" />
        </b-input-group>

        <b-input-group size="sm">
            <b-input v-model="component.deadwax" placeholder="Matrix" tabindex="-1" />
            <b-input v-model="component.address" placeholder="Address" tabindex="-1" />
            <b-input v-model="component.locale" placeholder="Locale" tabindex="-1" />
        </b-input-group>
    </div>
</template>

<script>
    import objectMixin from "../../mixins/object";
    import formatterMixin from "../../mixins/formatter";

    export default {
        name: "ItemLabel",
        props: [ 'label' ],
        mixins: [ objectMixin, formatterMixin ],
        data() {
            return {
                isSyncing: false, // Flag to prevent emit during prop sync
            }
        },
        created() {
            if (!this.label) {
                this.label = {
                    name: '',
                    catalogNo: '',
                }
            }
            this.clone(this.label);
        },
        watch: {
            label: {
                handler(newLabel) {
                    // Only update if the label actually changed to prevent infinite loops
                    const newLabelStr = JSON.stringify(newLabel || { name: '', catalogNo: '' });
                    const currentComponentStr = JSON.stringify(this.component || {});
                    
                    if (newLabelStr !== currentComponentStr) {
                        this.isSyncing = true; // Prevent emit during sync
                        this.$nextTick(() => {
                            if (newLabel) {
                                this.clone(newLabel);
                            } else {
                                this.clone({
                                    name: '',
                                    catalogNo: '',
                                });
                            }
                            this.$nextTick(() => {
                                this.isSyncing = false;
                            });
                        });
                    }
                },
                deep: true,
            },
            // Override the mixin's component watcher to prevent emits during sync
            component: {
                handler(newValue, oldValue) {
                    // Only emit if we're not syncing from prop changes
                    // The mixin's watcher checks if oldValue has keys, so we need to respect that too
                    if (!this.isSyncing && Object.keys(oldValue).length) {
                        this.$emit('update', this.component);
                    }
                },
                deep: true,
            }
        }
    }
</script>

<style scoped>

</style>